import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCreateAccountStore = defineStore('createAccount', () => {
  const formFields = ref({
    accountName: '',
    accountNameFriendly: '',
    main_website: '',
    a5Account: 0,
    initials: '',
    stateCode: '',
    countryCode: 'US',
    clientId: '',
    parentAccount: '',
    isParent: true,
    image: '',
    timezone: '',
    dealerPA: '',
    accountType: 'unspecified',
    accountTypeFord: false,

    primaryContact: {
      name: '',
      email: '',
      phone: '',
    },
    billing: {
      name: '',
      address_1: '',
      address_2: '',
      city: '',
      state: '',
      zip: '',
    },
    notes: '',
    // secondaryProducts: [] as string[],
    // a5Account: '',
    // paCode: '',
  })

  // Action to toggle secondary products
  // const setSecondaryProduct = (product: string, isChecked: boolean) => {
  //     if (isChecked) {
  //         if (!formFields.value.secondaryProducts.includes(product)) {
  //             formFields.value.secondaryProducts.push(product);
  //         }
  //     } else {
  //         formFields.value.secondaryProducts = formFields.value.secondaryProducts.filter(
  //             (item) => item !== product
  //         );
  //     }
  // };
  return { formFields }
})
